import { ComponentProps, forwardRef } from "react";
import { styled, Text, Image as TGImage } from "tamagui";

import { Button, ButtonRef } from "../../ui/button";
import { Card } from "../../ui/card";
import { Tag } from "../../ui/tag";

type ContainerProps = ComponentProps<typeof Card>;

const Container: React.FC<ContainerProps> = (props) => {
  return (
    <Card
      gap={"$4"}
      paddingHorizontal="$2"
      alignItems="center"
      shadow="md"
      {...props}
    />
  );
};

type ImageProps = ComponentProps<typeof TGImage> & { path?: string };

const Image: React.FC<ImageProps> = ({ path, source, ...props }) => {
  return (
    <TGImage
      style={{
        maxWidth: 120,
        maxHeight: 120,
      }}
      $sm={{
        maxWidth: 100,
        maxHeight: 100,
      }}
      source={path ? { width: 120, height: 120, uri: path } : source}
      {...props}
    />
  );
};

const RecommendationText = styled(Text, {
  name: "RecommendationText",
  fontFamily: "$subtitle",
  color: "$gray-950",
  textAlign: "center",
  variants: {
    font: {
      lg: {
        fontWeight: "$5",
        fontSize: "$4",
        lineHeight: "$4",
      },
      md: {
        fontWeight: "$5",
        fontSize: "$3",
        lineHeight: "$3",
      },
    },
  } as const,
  defaultVariants: {
    font: "lg",
  },
});

type ButtonProps = ComponentProps<typeof Button>;

const Trigger = forwardRef<ButtonRef, ButtonProps>((props, ref) => {
  return (
    <Button
      rounded="lg"
      variant="outlined"
      size="md"
      {...props}
      ref={ref}
      width={"100%"}
    />
  );
});

export const Recommendation = {
  Container,
  Image,
  Tag,
  Text: RecommendationText,
  Button: Trigger,
};
